import Button from '@/atoms/Button';
import getCtaProps from 'utils/cms/getCtaProps';
import { CMSCallToActionType } from 'utils/cms/types';

type WidgetCTAProps = {
  cta: CMSCallToActionType;
  widgetId: string;
  className?: string;
  onClick?: () => void;
};

const WidgetCTA = ({ cta, className, onClick }: WidgetCTAProps) => (
  <Button className={className} {...getCtaProps(cta)} onClick={onClick}>
    {cta.link?.title}
  </Button>
);

export default WidgetCTA;
